import {
	Breadcrumb,
	ContextResponse,
	ImageInfo,
	IngredientsInfo,
	NutritionResponse,
	NutritionVerification,
	PriceResponse,
	ProductDetailsResponse,
	ProductResponse,
	ProductStoresStockLevelResponse,
	ProductTag,
	QuantityResponse,
	SizeResponse,
} from '@woolworthsnz/trader-api';
import { SiteDetail } from '@woolworthsnz/store-locator';

export const isProductReponse = (response: ProductResponse | ProductDetailsResponse): response is ProductResponse => {
	const productResponse = response as ProductResponse;
	return !!productResponse?.adId || !!productResponse?.brand;
};

export const isProductDetailsReponse = (
	response: ProductResponse | ProductDetailsResponse
): response is ProductDetailsResponse => {
	const productResponse = response as ProductDetailsResponse;
	return !!productResponse?.images?.length || !!productResponse?.breadcrumb;
};

export const extractQLCodeFromCtaName = (ctaName: string | undefined): string | undefined => {
	const parts = ctaName?.split('|').map((part) => part.trim());
	return parts?.find((part) => part.startsWith('CI-')) || parts?.find((part) => part.startsWith('QL-'));
};

export interface ProductDetails {
	sku?: string;
	name?: string;
	brand?: string;
	genericName?: string;
	variety?: string;
	bigImageUrl?: string;
	smallImageUrl?: string;
	breadcrumb?: Breadcrumb;
	images?: Array<ImageInfo>;
	unit?: ProductDetailsResponse.UnitEnum;
	quantity?: QuantityResponse;
	productStoresStockLevel?: ProductStoresStockLevelResponse;
	price?: PriceResponse;
	size?: SizeResponse;
	alcohol?: number;
	healthStarRating?: number;
	origins?: Array<string>;
	description?: string;
	shopperNotes?: string;
	allergens?: Array<string>;
	claims?: Array<string>;
	endorsements?: Array<string>;
	ingredients?: IngredientsInfo;
	nutrition?: Array<NutritionResponse>;
	warnings?: Array<string>;
	contents?: Array<string>;
	productDisclaimerMessage?: string;
	nutritionVerificationMessage?: NutritionVerification;
	productTags?: Array<ProductTag>;
	averageWeightPerUnit?: number;
	supportsBothEachAndKgPricing?: boolean;
	selectedPurchasingUnit?: ProductDetailsResponse.SelectedPurchasingUnitEnum;
	availabilityStatus?: string;
	lastAvailableListPrice?: number;
	/**
	 * Indicates if the response is successful or not
	 */
	isSuccessful?: boolean;
	/**
	 * Gets the base url for the main shopping site
	 */
	rootUrl?: string;
	/**
	 * The shoppers context which contains Session state
	 */
	context?: ContextResponse;
	/**
	 * Informational messages to display to the shopper that are generated in the session.  Could be anything from the delivery window is running out etc...
	 */
	messages?: Array<string>;
	/**
	 * Citrus Ad Id if this product is displayed as a sponsored product
	 */
	adId?: string;
	category?: string;
	/**
	 * Store locator store details
	 */
	storeInfo?: SiteDetail;
	allergenMaybePresent?: string;
	directions?: string;
	servingSuggestion?: string;
}
